import * as React from "react";

export const ImagineLogo = ({ mode = "dark", scale = "160" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scale}
    // height="29"
    fill="none"
    viewBox="0 0 160 29"
  >
    <g clipPath="url(#clip0_1_62)">
      <mask
        id="mask0_1_62"
        width="160"
        height="29"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
      >
        <path fill="#fff" d="M160 0H0v29h160z"></path>
      </mask>
      <g mask="url(#mask0_1_62)">
        <path fill="#919191" d="M17.024 19.333 25.272 29h8.776z"></path>
        <path fill="#727272" d="m17.025 19.333-.033.019L0 29h8.776z"></path>
        <path fill="#828282" d="M17.024 19.333 20.602 29h4.67z"></path>
        <path
          fill="#828282"
          d="M17.024 29h3.578l-3.578-9.667zM13.447 29h3.577v-9.667z"
        ></path>
        <path fill="#828282" d="M17.024 19.333 8.777 29h4.67z"></path>
        <path
          fill="#D7D7D7"
          d="m17.024 19.333.024.013 17 9.653-4.388-7.475z"
        ></path>
        <path
          fill="#E6E6E6"
          d="m17.024 19.333 12.636 2.191-2.335-3.978z"
        ></path>
        <path
          fill="#E6E6E6"
          d="m17.024 19.333 10.301-1.787-1.788-3.046zM25.537 14.5l-1.79-3.047-6.723 7.88z"
        ></path>
        <path fill="#E6E6E6" d="m17.024 19.333 6.724-7.88-2.335-3.978z"></path>
        <path fill="#F6F6F6" d="m17.024 19.333 4.389-11.858L17.024 0z"></path>
        <path fill="#262626" d="M0 29"></path>
        <path fill="#242424" d="M17.025 19.333V0l-4.389 7.475z"></path>
        <path fill="#434343" d="M17.025 19.333 4.389 21.524 0 29z"></path>
        <path fill="#333" d="M17.024 19.333 12.636 7.475 10.3 11.453z"></path>
        <path
          fill="#333"
          d="M10.3 11.453 8.513 14.5l8.513 4.833zM17.024 19.333 8.512 14.5l-1.788 3.046z"
        ></path>
        <path fill="#333" d="m17.024 19.333-10.3-1.787-2.335 3.978z"></path>
        <g style={{ mixBlendMode: "color" }}>
          <mask
            id="mask1_1_62"
            width="35"
            height="30"
            x="0"
            y="-1"
            maskUnits="userSpaceOnUse"
            style={{ maskType: "alpha" }}
          >
            <g style={{ mixBlendMode: "color" }}>
              <path
                fill="#fff"
                fillRule="evenodd"
                d="m0 28.999 17.025-9.667-.033.02zh34.047l-15.855-9.003 15.856 9.003-4.389-7.475-2.335-3.978-1.788-3.047-1.789-3.047-2.335-3.978L17.024 0l-4.388 7.475-2.335 3.978L8.512 14.5l-1.788 3.047-2.335 3.978zm0 0"
                clipRule="evenodd"
                style={{ mixBlendMode: "difference" }}
              ></path>
            </g>
          </mask>
          <g mask="url(#mask1_1_62)">
            <path fill="#DD5E27" d="M33.8 0H0v29h33.8z"></path>
          </g>
        </g>
        <path
          fill={mode === "dark" ? "#262626" : "#D5D5D5"}
          d="M44.878 5.09v2.779h2.916v-2.78zm.184 5.165v13.37h2.574v-13.37z"
        />
        <path
          fill={mode === "dark" ? "#262626" : "#D5D5D5"}
          d="M50.5 23.625h2.573V15.42c0-2.019 1.209-3.356 3.126-3.356 1.97 0 2.337 1.206 2.337 2.99v8.572h2.574V15.42c0-2.019 1.208-3.356 3.125-3.356 1.97 0 2.338 1.206 2.338 2.99v8.572h2.574v-9.28c0-2.858-1.366-4.484-4.071-4.484-2.075 0-3.414 1.049-4.386 2.333h-.053c-.551-1.494-1.68-2.333-3.545-2.333-2.023 0-3.257 1.049-3.966 2.071h-.053v-1.678H50.5z"
        />
        <path
          fill={mode === "dark" ? "#262626" : "#D5D5D5"}
          d="M75.544 23.992c2.18 0 3.703-.865 4.596-2.254h.052c.132 1.52.841 2.018 2.101 2.018.42 0 .867-.052 1.313-.157v-1.573c-.157.026-.236.026-.314.026-.5 0-.631-.498-.631-1.468v-6.135c0-3.46-2.206-4.614-4.964-4.614-4.097 0-5.778 2.019-5.909 4.588h2.627c.131-1.783.84-2.517 3.177-2.517 1.97 0 2.548.813 2.548 1.783 0 1.31-1.287 1.573-3.388 1.966-3.335.656-5.594 1.52-5.594 4.51 0 2.28 1.707 3.827 4.386 3.827m.578-2.071c-1.603 0-2.26-.682-2.26-1.94 0-1.39.973-2.019 3.337-2.517 1.365-.288 2.52-.577 2.94-.97v1.914c0 2.333-1.706 3.513-4.017 3.513"
        />
        <path
          fill={mode === "dark" ? "#262626" : "#D5D5D5"}
          d="M95.017 22.734c0 2.516-1.26 3.591-3.703 3.591-2.18 0-3.099-.943-3.362-2.15h-2.653c.263 2.413 2.18 4.248 6.015 4.248s6.277-1.81 6.277-5.847V10.255h-2.574v1.572h-.053c-.735-.943-1.97-1.966-4.123-1.966-3.335 0-5.91 2.255-5.91 6.554 0 4.274 2.575 6.529 5.91 6.529 2.154 0 3.388-.944 4.123-2.02h.053zM91.314 12.01c2.31 0 3.677 1.468 3.677 4.404 0 2.91-1.366 4.405-3.677 4.405-2.521 0-3.703-1.888-3.703-4.405 0-2.516 1.182-4.404 3.703-4.404"
        />
        <path
          fill={mode === "dark" ? "#262626" : "#D5D5D5"}
          d="M100.304 5.09v2.779h2.915v-2.78zm.183 5.165v13.37h2.575v-13.37z"
        />
        <path
          fill={mode === "dark" ? "#262626" : "#D5D5D5"}
          d="M105.925 23.625h2.574V15.42c0-2.019 1.418-3.356 3.624-3.356 1.917 0 2.705 1.206 2.705 2.99v8.572h2.6v-9.28c0-3.068-1.995-4.484-4.464-4.484-2.311 0-3.704 1.049-4.413 2.071h-.052v-1.678h-2.574z"
        />
        <path
          fill={mode === "dark" ? "#262626" : "#D5D5D5"}
          d="M126.073 24.018c3.519 0 5.489-1.94 6.171-4.509h-2.6c-.262.891-1.155 2.412-3.519 2.412-2.653 0-3.966-2.045-4.018-4.3h10.295c.026-.21.026-.603.026-.97 0-4.142-2.285-6.816-6.355-6.816-4.098 0-6.619 2.884-6.619 7.078 0 4.09 2.364 7.105 6.619 7.105m-.08-12.086c2.285 0 3.73 1.573 3.73 3.67h-7.616c.157-2.202 1.733-3.67 3.886-3.67"
        />
        <path
          fill={mode === "dark" ? "#262626" : "#D5D5D5"}
          d="M133.39 20.767v2.858h2.863v-2.858z"
        />
        <path
          fill={mode === "dark" ? "#262626" : "#D5D5D5"}
          d="M139.597 5.09v2.779h2.915v-2.78zm.184 5.165v13.37h2.574v-13.37z"
        />
        <path
          fill={mode === "dark" ? "#262626" : "#D5D5D5"}
          d="M151.184 24.018c4.175 0 6.696-2.91 6.696-7.105 0-4.168-2.521-7.078-6.696-7.078-4.177 0-6.698 2.936-6.698 7.105 0 4.194 2.521 7.078 6.698 7.078m0-2.123c-2.758 0-4.019-2.176-4.019-4.955 0-2.806 1.261-4.955 4.019-4.955 2.731 0 4.018 2.15 4.018 4.955 0 2.779-1.287 4.955-4.018 4.955"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1_62">
        <path fill="#fff" d="M0 0h160v29H0z"></path>
      </clipPath>
    </defs>
  </svg>
);
